// import axios from "axios";
import getLogger from "logger/index";
import { config } from "api/config";
const log = getLogger("PROFILE_REQUEST");
import { get } from "util/apiRequest";
import { getDynamicRoute } from "util/createProfileIdPath";
//Team
export const TEAM_FAR_REQUEST = "TEAM_FAR_REQUEST";
export const TEAM_FAR_SUCCESS = "TEAM_FAR_SUCCESS";
export const TEAM_FAR_FAILURE = "TEAM_FAR_FAILURE";

export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";

export function teamFarRequest() {
  return {
    type: TEAM_FAR_REQUEST,
    status: REQUESTING,
  };
}
export function teamFarSuccess(teamdetail) {
  return {
    type: TEAM_FAR_SUCCESS,
    status: SUCCESS,
    teamdetail,
  };
}
export function teamFarFailure(error) {
  return {
    type: TEAM_FAR_FAILURE,
    status: ERROR,
    error,
  };
}

export function teamFarProfile(advertiser_id, seoUserType, profileId) {
  return async (dispatch) => {
    dispatch(teamFarRequest());
    try {
      const result = await get(
        `${
          config.GATEWAY_URL
        }/${getDynamicRoute()}/api/v3/farprofile?fulfillment_id=${advertiser_id}&selectType=team&langCode=en&seoUserType=${seoUserType}&profileId=${profileId}`,
      );
      const resultJson = result;

      if (resultJson.error) {
        throw new Error(resultJson.error);
      }
      return dispatch(teamFarSuccess(resultJson.data));
    } catch (e) {
      const reqURL = `fulfillment_id=${advertiser_id}&selectType=team&langCode=en&seoUserType=${seoUserType}&profileId=${profileId}`;
      log.error("Error while fetching TEAM_REQUEST data : " + reqURL, e);
      dispatch(teamFarFailure(e.message));
    }
  };
}
